<script lang="ts">
  import { onMount } from "svelte"
  import Layout from "$app/Layouts/University.svelte"
  import CourseBox from "./CourseBox.svelte"
  import { ArrowLeft } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()

  let plan: PlanType = props.plan
  let current_user: UserType = props.current_user
  let courses = $state(props.courses || [])
  let purchased_courses = $state(props.purchased_courses || null)
  let course_progresses = $state(props.course_progresses || [])

  onMount(() => {
    appStore.plan = plan
    appStore.current_user = current_user

    courses = courses.map((c) => {
      let course_progress = course_progresses.find(function (cp) {
        if (cp.course_id === c.id) {
          return true
        }
      })
      return { ...c, progress: course_progress }
    })
  })
</script>

<Layout {...props}>
  <div
    class="bg-gradient-to-r from-course-bg-light to-course-bg-dark w-full border-t-border-b-2 border-gray-800"
  >
    <div
      class="mx-auto max-w-7xl grid grid-cols-1 md:grid-cols-3 items-center sm:px-6 lg:px-8"
    >
      <div class="flex justify-start items-center">
        <a
          href="/plans/{appStore.plan.id}/university"
          class="flex items-center justify-start gap-1 hover:border-b hover:font-bold text-white"
        >
          <ArrowLeft class="size-6 text-core" />
          Back to University
        </a>
      </div>
      <div class="py-3">
        <div class="flex items-center justify-center">
          <img
            class="inline-block h-6 w-6 rounded-full shadow bg-gray-50 p-1"
            src={appStore.plan.logo_url}
            alt="Logo"
          />
          <p
            class="text-base leading-tight text-gray-200 ml-2"
            data-name="plan-name"
          >
            {appStore.plan.name}
          </p>
        </div>
        <h1 class="text-white text-2xl text-center mt-1">Courses</h1>
      </div>

      <div></div>
    </div>
  </div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 py-8">
      {#each courses as course}
        <CourseBox {course} {course_progresses} {purchased_courses} />
      {/each}
    </div>
  </div>
</Layout>
